/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 機器分配管理資料頁面
 * @module MachineAssignmentContainer
 */

// ----- import from local libraries -----
import {React} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import {useDispatch} from 'react-redux';
import enumList from 'web/utils/enumList';
import {AlertModal} from 'web/components/modal/AlertModal';
import {useAlertModal} from 'web/components/modal/hooks/useAlertModal';
import {useRef, useState} from 'react';
// import {editMachineStatus} from 'web/redux/actions/RelCustomerMachineActions'; ＊ 找不到這個 module 先註解，避免前端報錯
import {showMessage} from 'web/utils/modalHelper';
import MachineModal from './components/MachineModal';
import MachineAssignmentPage from './components/MachineAssignmentPage';

// ----- constants and enums -----

const MachineAssignmentContainer = (props) => {
  const dispatch = useDispatch();
  const [machineModalMode, setMachineModalMode] = useState(
    enumList.modalMode.new
  );
  const [needMachineAssignmentLoad, setNeedMachineAssignmentLoad] =
    useState(false);
  const [machineAssignmentItem, setMachineAssignmentItem] = useState({
    customerName: '',
    deliveryCode: '',
    machineModel: '',
    machineSerialNumber: '',
    machineType: '',
    memo: '',
  });

  const machineModalRef = useRef(null);

  const {alertRef, actionMode, actionIds, alertMessage, toggleAlertModal} =
    useAlertModal();

  const setMachineModalRef = (element) => {
    if (element && !machineModalRef.current) {
      machineModalRef.current = new bootstrap.Modal(element);
    }
  };

  // const handleEditMachineStatus = (machineCodes, status) => {
  //   dispatch(editMachineStatus({machineCodes, status}))
  //     .then((res) => {
  //       const statusCode = res.payload.code;
  //       if (statusCode && statusCode.isSuccessCode()) {
  //         setNeedMachineAssignmentLoad(true);
  //         showMessage(enumList.messageModalMode.info, '更新成功');
  //         toggleAlertModal(false);
  //       } else {
  //         showMessage(enumList.messageModalMode.error, res);
  //         toggleAlertModal(false);
  //       }
  //     })
  //     .catch((err) => {
  //       showMessage(enumList.messageModalMode.error, err);
  //       console.error('updateMachineStatus error', err);
  //     });
  // };

  const onConfirm = () => {
    const machineCodes = actionIds;
    const status =
      actionMode === enumList.alertModalModeEnums.enable
        ? enumList.flgStatus.active
        : enumList.flgStatus.inactive;

    if (
      actionMode === enumList.alertModalModeEnums.enable ||
      actionMode === enumList.alertModalModeEnums.disable
    ) {
      // handleEditMachineStatus(machineCodes, status);
    }
  };

  const toggleMachineAddModal = (isShow) => {
    setMachineModalMode(enumList.modalMode.new);
    setMachineAssignmentItem({
      machineCode: '',
      machineName: '',
      address: '',
      contactName: '',
      contactPhone: '',
      faxId: '',
      memo: '',
    });
    if (machineModalRef.current) {
      if (isShow) {
        machineModalRef.current.show();
      } else {
        machineModalRef.current.hide();
      }
    }
  };

  const toggleMachineEditModal = (isShow, machineItem) => {
    setMachineModalMode(enumList.modalMode.edit);
    setMachineAssignmentItem(machineItem);
    if (machineModalRef.current) {
      if (isShow) {
        machineModalRef.current.show();
      } else {
        machineModalRef.current.hide();
      }
    }
  };

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <MachineAssignmentPage
            {...props}
            toggleMachineAddModal={toggleMachineAddModal}
            toggleMachineEditModal={toggleMachineEditModal}
            onBatchHandle={(mode, message, machineCodes) =>
              toggleAlertModal(
                true,
                mode,
                enumList.targetAction.machine,
                message,
                machineCodes
              )
            }
            needMachineLoad={needMachineAssignmentLoad}
            setNeedMachineLoad={setNeedMachineAssignmentLoad}
          />
        </div>
        <Footer />
      </div>
      <AlertModal
        ref={alertRef}
        mode={actionMode}
        message={alertMessage}
        onConfirm={onConfirm}
        onCancel={() => setNeedMachineAssignmentLoad(true)}
      />
      <MachineModal
        {...props}
        ref={setMachineModalRef}
        mode={machineModalMode}
        machineItem={machineAssignmentItem}
        toggleMachineAddModal={toggleMachineAddModal}
        toggleMachineEditModal={toggleMachineEditModal}
        reloadDepartmentList={() => {
          setNeedMachineAssignmentLoad(true);
        }}
        onErrorHandle={(title, message) =>
          showMessage(true, enumList.messageModalMode.error, title, message)
        }
      />
    </>
  );
};

export default MachineAssignmentContainer;
